import React from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { IconButton, IconButtonProps } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

export const MoreButton = (props: IconButtonProps) => {
  return (
    <IconButton
      {...props}
      sx={{
        backgroundColor: circlesOrbitColorPalette.toolkit.main,
        borderRadius: '8px',
        padding: '4px 8px',
        margin: 'auto',
        color: circlesOrbitColorPalette.primary.dark
      }}
    >
      <MoreHorizIcon />
    </IconButton>
  )
}
